import React, { useEffect, useState } from 'react';
import './CheckoutProduct.css';
import { useStateValue } from '../StateProvider/StateProvider';
import star from '../../assets/images/star.png';

function CheckoutProduct({
  id,
  title,
  image,
  price,
  rating,
  hideButton,
  quantity,
  description,
  showCheckbox,
}) {
  const [
    { cart, selectedCartItems, totalSelectedCartItems },
    dispatch,
  ] = useStateValue();
  const quantities = 11;
  const [showCustomQuantity, setShowCustomQuantity] = useState(false);
  const priceDollars = price.toString().split('.')[0];
  let priceCents = price.toString().split('.')[1];
  if (priceCents === undefined) priceCents = '00';
  if (priceCents.length < 2) priceCents += '0';

  const removeFromCart = (event) => {
    event.preventDefault();
    dispatch({
      type: 'REMOVE_FROM_CART',
      id: id,
    });
  };

  const setQuantity = (event) => {
    if (showCustomQuantity === false) {
      let quantitySelect = document.getElementById(`checkoutProduct${id}`);
      if (quantity < 10) {
        quantitySelect.value = quantity;
      } else {
        setShowCustomQuantity(true);
        if (showCustomQuantity === true) setCustomQuantity(quantity);
      }
    } else {
      let customQuantityInput = document.getElementById(
        `checkoutProduct${id}CustomQuantityInput`
      );
      customQuantityInput.value = quantity;
    }
  };

  const displayCheckbox = () => {
    let checkbox = document.getElementById(`productCheckbox-${id}`);
    if (showCheckbox === false)
      checkbox.parentElement.parentElement.style.display = 'none';
  };

  const setNewProductQuantity = (event, customQuantity = null) => {
    let dispatchObject;
    let index = cart.map((product) => product.item.id).indexOf(id);
    let selectedCartItemsIndex = selectedCartItems
      .map((product) => product.item.id)
      .indexOf(id);
    let newCart = cart;
    let newSelectedCartItems = selectedCartItems;
    let oldQuantity = newCart[index].quantity;
    let newQuantity =
      customQuantity === null ? Number(event.target.value) : customQuantity;
    let quantityChange;
    if (oldQuantity < newQuantity) {
      quantityChange = newQuantity - oldQuantity;
    } else {
      quantityChange = -Math.abs(oldQuantity - newQuantity);
    }
    if (newQuantity === 0) {
      dispatch({
        type: 'REMOVE_FROM_CART',
        id: id,
      });
    } else if (newQuantity > 0 && newQuantity < 10) {
      if (newQuantity < 10) setShowCustomQuantity(false);
      newCart[index].quantity = newQuantity;
      newSelectedCartItems[selectedCartItemsIndex].quantity = newQuantity;
      let checkbox = document.getElementById(`productCheckbox-${id}`);
      if (selectedCartItemsIndex === -1 && checkbox.checked === true) {
        dispatchObject = {
          type: 'CHANGE_QUANTITY_CHECKOUT',
          cart: newCart,
          quantityChange: quantityChange,
          item: {
            id: id,
            title: title,
            image: image,
            price: price,
            rating: rating,
            description: description,
          },
          quantity: newQuantity,
        };
      } else {
        dispatchObject = {
          type: 'CHANGE_QUANTITY_CHECKOUT',
          cart: newCart,
          selectedCartItems: newSelectedCartItems,
          quantityChange: quantityChange,
          quantity: newQuantity,
        };
      }
      dispatch(dispatchObject);
    } else if (newQuantity >= 10) {
      if (showCustomQuantity === false) {
        setShowCustomQuantity(true);
      } else {
        newCart[index].quantity = newQuantity;
        newSelectedCartItems[selectedCartItemsIndex].quantity = newQuantity;
        dispatchObject = {
          type: 'CHANGE_QUANTITY_CHECKOUT',
          cart: newCart,
          selectedCartItems: newSelectedCartItems,
          quantityChange: quantityChange,
          quantity: newQuantity,
        };
        if (newQuantity < 10) setShowCustomQuantity(false);
        dispatch(dispatchObject);
      }
    }
  };

  const setCustomQuantity = (event, customQuantity = null) => {
    if (event !== undefined) event.preventDefault();
    if (customQuantity >= 10 && showCustomQuantity === false) {
      setShowCustomQuantity(true);
    }
    let customQuantityInput = document.getElementById(
      `checkoutProduct${id}CustomQuantityInput`
    );
    let quantity =
      customQuantity === null
        ? Number(customQuantityInput.value)
        : customQuantity;

    if (customQuantityInput != null)
      customQuantityInput.value = quantity.toString();
    setNewProductQuantity(event, quantity);
  };

  const isolateSubtotal = () => {
    let index = selectedCartItems.map((product) => product.item.id).indexOf(id);
    if (index === -1) {
      dispatch({
        type: 'ADD_SELECTED_CART_ITEM',
        item: {
          id: id,
          title: title,
          image: image,
          price: price,
          rating: rating,
          description: description,
        },
        quantity: quantity,
        totalSelectedCartItems: totalSelectedCartItems + quantity,
      });
    } else {
      dispatch({
        type: 'REMOVE_SELECTED_CART_ITEM',
        id: id,
        quantity: quantity,
      });
    }
  };

  // if (showCustomQuantity === true) {
  //   let customQuantityInput = document.getElementById(
  //     `checkoutProduct${id}CustomQuantityInput`
  //   );
  // }

  useEffect(() => {
    displayCheckbox();
    setQuantity();
  });

  return (
    <div className="checkoutProduct">
      <div className="checkoutProduct__checkboxColumn">
        <label className="checkoutProduct__checkboxContainer">
          <input
            onChange={isolateSubtotal}
            className="checkoutProduct__checkbox"
            type="checkbox"
            id={`productCheckbox-${id}`}
          />
          <span className="checkoutProduct__checkmark"></span>
        </label>
      </div>

      <img className="checkoutProduct__image" src={image} alt="" />
      <div className="checkoutProduct__info">
        <p className="checkoutProduct__title">{title}</p>
        <div className="checkoutProduct__rating">
          {Array(rating)
            .fill()
            .map((_, index) => (
              <p key={index}>
                <img className="product__ratingStar" src={star} alt="" />
              </p>
            ))}
        </div>
        <p className="checkoutProduct__info checkoutProduct__inStock">
          In Stock
        </p>
        <p className="checkoutProduct__info">Eligible for FREE Shipping</p>
        <form>
          {showCustomQuantity === false ? (
            <select
              onChange={setNewProductQuantity}
              className="checkoutProduct__quantitySelect"
              name="quantitySelect"
              id={`checkoutProduct${id}`}
            >
              {Array(quantities)
                .fill()
                .map((_, index) => (
                  <option value={index} key={index}>
                    Qty: {index < 10 ? index : `${index}+`}
                  </option>
                ))}
            </select>
          ) : (
            <div className="checkoutProduct__customQuantityInputContainer">
              <span>Quantity: </span>
              <input
                id={`checkoutProduct${id}CustomQuantityInput`}
                className="checkoutProduct__customQuantityInput"
                type="text"
              ></input>
              <button onClick={setCustomQuantity} className="app__button">
                Update
              </button>
            </div>
          )}

          <span className="checkoutProduct__verticalBar">|</span>
          <a
            className="checkoutProduct__deleteLink"
            href="true"
            onClick={removeFromCart}
          >
            Delete
          </a>
        </form>
      </div>
      <div className="checkoutProduct__priceContainer">
        <p className="checkoutProduct__price">
          <span className="app__priceSymbol">$</span>
          <strong className="app__priceDollars">{priceDollars}</strong>
          <span className="app__priceCents">{priceCents}</span>
        </p>
      </div>
    </div>
  );
}

export default CheckoutProduct;
